import React from 'react';

import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import { Box, Stack, Typography } from '@mui/material';

import { RICHARD_MICROCOPY, formatSteerLabel } from '../chat/microcopy';

interface SteerNotesProps {
  steers: ReadonlyArray<string>;
  pending: ReadonlyArray<string>;
}

export default function SteerNotes({ steers, pending }: SteerNotesProps) {
  if (steers.length === 0 && pending.length === 0) {
    return null;
  }
  return (
    <Stack spacing={0.75} sx={{ my: 1 }}>
      {steers.map((steer, index) => (
        <Box
          key={`steered-${index}`}
          data-testid="ui-stream-steer"
          data-acknowledged="true"
          sx={{ pl: 1.5, py: 0.25, borderLeft: 2, borderColor: 'primary.main' }}
        >
          <Typography sx={{ fontSize: 13, color: 'text.primary', overflowWrap: 'anywhere' }}>
            {formatSteerLabel(steer)}
          </Typography>
          <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mt: 0.25, color: 'primary.main' }}>
            <SubdirectoryArrowRightIcon sx={{ fontSize: 14 }} />
            <Typography sx={{ fontSize: 12, color: 'primary.main' }}>
              {RICHARD_MICROCOPY.steerAdjustedCourse}
            </Typography>
          </Stack>
        </Box>
      ))}
      {pending.map((steer, index) => (
        <Box
          key={`pending-${index}`}
          data-testid="ui-stream-steer"
          data-acknowledged="false"
          sx={{ pl: 1.5, py: 0.25, borderLeft: 2, borderColor: 'divider' }}
        >
          <Typography sx={{ fontSize: 13, color: 'text.secondary', overflowWrap: 'anywhere' }}>
            {formatSteerLabel(steer)}
          </Typography>
          <Typography sx={{ fontSize: 12, color: 'text.disabled' }}>Sent.</Typography>
        </Box>
      ))}
    </Stack>
  );
}
